import React, {Component} from "react";
import {
    BILATERAL_CONTROL_PANEL_ROUTE
} from "../../../../utils/constants/RoutesConstants";
import BilateralCaptureGuaranteeView from "./BilateralCaptureGuaranteeView";
import {Growl} from "primereact/growl";
import ConfirmationMessage from "../../../../components/confirmationMessage";
import PropTypes from "prop-types";
import {amountCalculate} from "../../../../utils/formatters/Numbers";
import {BilateralLoanService} from "../../../../service/bilateral/loan/BilateralLoanService";

export default class BilateralCaptureGuaranteeContainer extends Component {
    constructor(props) {
        super(props);

        this.bilateralLoanService = new BilateralLoanService();
        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveGuarantees = this.saveGuarantees.bind(this);
        this.openConfirmationReject = this.openConfirmationReject.bind(this);
        this.rejectBilateralLoan = this.rejectBilateralLoan.bind(this);
        this.onChangeAccount = this.onChangeAccount.bind(this);
        this.getCollateralListFromMap = this.getCollateralListFromMap.bind(this);
        this.validAccount = this.validAccount.bind(this);
        this.validGuaranteedAmount = this.validGuaranteedAmount.bind(this);
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };
        this.state = {
            isLoading: true,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            borrowerAccount: ''
        };

        this.guaranteeInAccount = React.createRef();
        this.bilateralLoanData = React.createRef();
    };

    componentDidMount() {
        let loanId = this.props.location.state.selectedLoanControlPanel.id;
        this.getDetailLoan(loanId);

    }

    getDetailLoan(loanId){
        this.bilateralLoanService.getLoanDetail(loanId, false)
            .then( res => {
                if (this.validResponse(res)){
                    this.setState({
                        selectedLoan: res.data,
                    });
                    this.setLoanDetail(res.data);
                }
            });
    }

    setLoanDetail(loanData) {
        this.bilateralLoanData.current.state.selectedLoan = loanData ;
        this.bilateralLoanData.current.getLoan();
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: BILATERAL_CONTROL_PANEL_ROUTE,
            message: message
        });
    }

    saveGuarantees() {
        if (this.validAccount() && this.validGuaranteedAmount()) {
            this.loading(true);
            let params = {
                loanId: this.state.selectedLoan.id,
                borrowerAccount: this.state.borrowerAccount,
                collateralsToAssign:
                    this.getCollateralListFromMap(this.guaranteeInAccount.current.state.collateralToAssignMap)
            };
            this.bilateralLoanService.saveCollateralsArrangement(params).then(
                res => {
                    if (this.validResponse(res)) {
                        this.loading(true);
                        this.handleReturnButton({
                            severity: 'success',
                            sumary: 'Éxito',
                            detail: 'Las garantías han sido guardadas exitosamente',
                        });
                    }
                });
        }
    }
    validGuaranteedAmount() {
        if (this.state.selectedLoan.amount >
            amountCalculate(this.guaranteeInAccount.current.state.guaranteedAmountTotal)) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar las garantías"});
            return false;
        }
        return true;
    }
    validAccount(){
        if (this.state.borrowerAccount === '' || this.state.borrowerAccount === undefined) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar la cuenta"});
            return false
        }
        return true;
    }
    getCollateralListFromMap(collateralMap) {
        let collateralList =[];
        for (const [key, value] of collateralMap) {
            collateralList.push({
                instrumentId: key,
                title: value
            });
        }
        return collateralList;
    }
    validResponse (res){
        if (res.status!== 200){
            this.growl.show({severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }


    rejectBilateralLoan() {
        //TODO reject Loan
    }

    openConfirmationReject() {
        if (this.confirmationRef) {
            this.confirmationRef.openConfirmationMessage();
        }
    }
    onChangeAccount(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,});
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Está seguro que desea rechazar este préstamo?"
                                           action={this.rejectBilateralLoan}/>;

        return <BilateralCaptureGuaranteeView
            isLoading={this.state.isLoading}
            guaranteeInAccount={this.guaranteeInAccount}
            selectedLoan={this.state.selectedLoan}
            borrowerAccount={this.state.borrowerAccount}
            messagesGrowl={messagesGrowl}
            confirmationMessage={confMsg}
            loading={this.loading}
            handleReturnButton={this.handleReturnButton}
            saveGuarantees={this.saveGuarantees}
            openConfirmationReject={this.openConfirmationReject}
            onChangeAccount={this.onChangeAccount}
            bilateralLoanData={this.bilateralLoanData}
        />
    }
};
BilateralCaptureGuaranteeContainer.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};